module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui raised clearing segment"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "padding-bottom": "10px",
      "border-bottom": "1px solid #eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "font-size": "16px"
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerDetails($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.reservation.code))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "130px"
    }
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" " + _vm._s(_vm.reservation.contact.firstName) + " " + _vm._s(_vm.reservation.contact.lastName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    }
  }, [_c('i', {
    staticClass: "ship icon"
  }), _vm._v(" " + _vm._s(_vm.reservation.boat.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "230px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.moment(_vm.reservation.firstBooking.date).format('ll')) + ": "), _c('strong', {
    staticClass: "ui basic large label"
  }, [_vm._v(_vm._s(_vm.starts) + " - " + _vm._s(_vm.ends) + "h")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px"
    }
  }, [(_vm.reservation.confirmed) ? _c('div', {
    staticClass: "ui label"
  }, [_vm._v(_vm._s(_vm.reservation.status))]) : _c('div', {
    staticClass: "ui yellow label"
  }, [_vm._v("unconfirmed")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px"
    }
  }, [(_vm.reservation.payment.status == 'paid') ? _c('div', {
    staticClass: "ui small icon label"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Paid")]) : _vm._e(), _vm._v(" "), (_vm.reservation.payment.status == 'unpaid') ? _c('div', {
    staticClass: "ui small label",
    class: {
      'red': _vm.reservation.status == 'returned' && _vm.reservation.payment.status == 'unpaid'
    }
  }, [_vm._v("Unpaid: "), _c('strong', [_vm._v("€" + _vm._s(_vm.reservation.payment.toPay))])]) : _vm._e(), _vm._v(" "), (_vm.reservation.payment.status == 'refund') ? _c('div', {
    staticClass: "ui small label",
    class: {
      'orange': _vm.reservation.payment.status == 'refund'
    }
  }, [_vm._v("Refund: -"), _c('strong', [_vm._v("€" + _vm._s(Math.abs(_vm.reservation.payment.toPay)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui tiny buttons"
  }, [(_vm.reservation.status == 'reserved') ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.checkIn
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Check In")]) : _vm._e(), _vm._v(" "), (_vm.reservation.status == 'inProgress' ||
    _vm.reservation.status == 'checkIn' ||
    (_vm.reservation.status == 'returned' && (_vm.reservation.payment.status == 'unpaid' || _vm.reservation.payment.status == 'refund'))) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.paid
    }
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(" Paid")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui floating dropdown blue icon button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.checkIn
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Check In")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.paid
    }
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(" Paid")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.checkOut
    }
  }, [_c('i', {
    staticClass: "sign out icon"
  }), _vm._v(" Check Out")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.triggerDetails
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v(" View Details")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0",
      "border-bottom": "1px solid #eeeeee",
      "font-size": "13px"
    }
  }, [_c('strong', [_vm._v("Booked At:")]), _vm._v(" " + _vm._s(_vm.moment(_vm.reservation.createdAt).format('MMM DD, HH:mm')) + "\n    • "), _c('strong', [_vm._v("People:")]), _vm._v(" " + _vm._s(_vm.reservation.people) + "\n    • "), _c('strong', [_vm._v("Telephone:")]), _vm._v(" " + _vm._s(_vm.reservation.contact.tel) + "\n    • "), _c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.reservation.contact.email) + "\n    "), (_vm.reservation.contact.company) ? _c('span', [_vm._v(" • "), _c('strong', [_vm._v("Company:")]), _vm._v(" " + _vm._s(_vm.reservation.contact.company))]) : _vm._e(), _vm._v(" "), (_vm.reservation.discount) ? _c('span', [_vm._v(" • "), _c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.reservation.discount.voucher))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n    Reason: " + _vm._s(_vm.reservation.reason) + "\n  ")]), _vm._v(" "), (_vm.reservation.wishes) ? _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0",
      "border-bottom": "1px solid #eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.wishesStatus || _vm.reservation.wishesStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])])]), _vm._v(" "), _c('strong', [_vm._v("WISHES:")]), _c('br'), _vm._v(_vm._s(_vm.reservation.wishes) + "\n    "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.reservation.questions) ? _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0",
      "border-bottom": "1px solid #eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "status-block"
  }, [_c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.questionsStatus || _vm.reservation.questionsStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])])])]), _vm._v(" "), _c('strong', [_vm._v("QUESTIONS:")]), _c('br'), _vm._v("\n\n    " + _vm._s(_vm.reservation.questions) + "\n    "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.reservation.services && _vm.reservation.services.length > 0) ? _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('strong', [_vm._v("SERVICES:")]), _c('br'), _vm._v(" "), _vm._l((_vm.reservation.services), function(service) {
    return _c('div', {
      staticClass: "service row"
    }, [_vm._v("\n      " + _vm._s(service.title) + "\n      "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(service.priceType === 'perPerson') ? _c('div', {
      staticClass: "ui mini labeled input"
    }, [_c('div', {
      staticClass: "ui label"
    }, [_vm._v("\n            P\n          ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.people),
        expression: "service.people"
      }],
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (service.people)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.people = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui basic tiny button",
      on: {
        "click": function($event) {
          _vm.toggleBillStatus(service._id)
        }
      }
    }, [(service.billed) ? _c('span', [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Billed")]) : _c('span', [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Off Bill")])]), _vm._v(" "), _c('div', {
      staticClass: "status-block"
    }, [_c('div', {
      staticClass: "ui dropdown"
    }, [_c('div', {
      staticClass: "text"
    }, [(!service.status || service.status === 'pending') ? _c('span', {
      staticClass: "pending service status"
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (service.status === 'inProgress') ? _c('span', {
      staticClass: "in-progress service status"
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (service.status === 'delivered') ? _c('span', {
      staticClass: "delivered service status"
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]) : _vm._e(), _vm._v(" "), (service.status === 'escalated') ? _c('span', {
      staticClass: "problem service status"
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu",
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'pending')
        }
      }
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'inProgress')
        }
      }
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'delivered')
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]), _vm._v(" "), _c('div', {
      staticClass: "ui divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'escalated')
        }
      }
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")])])])])])])
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43bf16ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reservations/ReservationRow.vue
// module id = 738
// module chunks = 1